module.exports = __webpack_public_path__ + "img/socials_fb.1a0a5452.svg";